import { useQuery } from "react-query";
import { getData } from "../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../api/ajax-endpoints";

const fetchOutwardTransferProviders = async () => {
  const response = await getData(ajaxEndpoints.FETCH_OUTWARD_PROVIDERS);
  return response?.data;
};

export const useFetchOutwardTransferProviders = () => {
  return useQuery("fetchOutwardTransferProviders", () =>
    fetchOutwardTransferProviders(),
  );
};
